// Stable key for the §3.7 scale keyboard done-set (engine v2). The done
// marks live in localStorage keyed by message. NEW keyboards carry a
// server-minted engine_scale.id (#4492) — Message.tsx keys on it first,
// because the session-start scale message is a FIXED template: a content
// key lets one answered session_start scale hide EVERY later session's
// keyboard. This hash remains the fallback for pre-id rows: the LIVE
// message is stamped with the client clock while the same row returns
// the server created_at from /history after a reload, so a timestamp key
// would let an ANSWERED keyboard resurrect, and content is identical on
// both paths (the engine's repeat_reply rail forbids verbatim duplicate
// MODEL replies).

export function scaleKey(content: string): string {
  // FNV-1a 32-bit — deterministic, no deps, collision-safe for this scale
  let h = 0x811c9dc5
  for (let i = 0; i < content.length; i++) {
    h ^= content.charCodeAt(i)
    h = Math.imul(h, 0x01000193)
  }
  return (h >>> 0).toString(36)
}
